import React from "react";

import { styled } from "@mui/material/styles";

import useQueryBoard from "../../lib/hooks/useQueryBoard";

import Clock from "../Clock";

const logo = new URL("../../assets/images/background.png", import.meta.url);

const MUIHeroImage = styled("header")({
  height: "54.5rem",

  "@media screen and (orientation: landscape)": {
    height: "38rem",
  },

  "& div": {
    height: "100%",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",

    "@media screen and (orientation: landscape)": {
      backgroundSize: "100% auto",
      backgroundPosition: "50% 77%",
    },
  },
});

const Header = React.memo(() => {
  const { data, dataUpdatedAt } = useQueryBoard();

  const imageURL = data?.digitalReception?.theme?.images?.hero?.absolutePath;

  return (
    <>
      <Clock />
      <MUIHeroImage key={dataUpdatedAt}>
        <div
          className="h-100 hero__image"
          style={{
            backgroundImage: `url("${imageURL ?? logo}")`,
          }}
        />
      </MUIHeroImage>
    </>
  );
});

export default Header;
